import { forwardRef, useState } from 'react';
import {
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons } from '../Icons';

export const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
  function PasswordInput(props, ref) {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    return (
      <InputGroup>
        <Input
          {...props}
          ref={ref}
          type={visible ? 'text' : 'password'}
          pr="3rem"
        />
        <InputRightElement>
          <IconButton
            type="button"
            variant="ghost"
            size="sm"
            aria-label={t(visible ? 'auth.hidePassword' : 'auth.showPassword')}
            aria-pressed={visible}
            isDisabled={props.isDisabled}
            icon={visible ? <Icons.EyeOff /> : <Icons.Eye />}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => setVisible(!visible)}
          />
        </InputRightElement>
      </InputGroup>
    );
  },
);
